



































import { Vue, Component, Prop } from 'vue-property-decorator';

import Editor from '@/views/components/quill-editor.vue';
import * as validators from '@/utils/validator';
import * as api from '@/api';

/**
 * 添加RG 模板
 *
 * @author liyuyao
 * @date 03/28/2019
 */
@Component({
    components: {
        Editor
    }
})
export default class AddRgTemplateDialog extends Vue {
    @Prop({ default: false })
    isEdit: Boolean;

    @Prop({ default: 0 })
    templateId: number;

    visible: Boolean = true;
    formCustom: any = {
        name: '',
        content: ''
    };
    btnLoading: Boolean = false;
    searchLoading: Boolean = false;
    $refs: any;

    ruleCustom = {
        name: [{ validator: validators.validateName, trigger: 'blur' }]
    };
    defaultPlaceholder: string = '<p>模板内容示例</p><p>【页面链接】：</p><p>【所属模块】：</p><p>【Appkey】：</p>';

    mounted() {
        if (this.isEdit && this.templateId) {
            this.getTemplateDetail();
        } else {
            this.formCustom.content = this.defaultPlaceholder;
        }
    }
    handleContentChange(val) {
        this.formCustom.content = val;
    }
    // 获取模板内容（编辑）
    async getTemplateDetail() {
        try {
            const res = await api.rgApi.getTemplateById(this.templateId);
            const { code, data } = res;
            if (code === 200) {
                this.formCustom.name = data.name;
                this.formCustom.content = data.content || this.defaultPlaceholder;
            }
        } catch (e) {
            console.log(e);
        }
    }
    // 提交模板创建/修改
    async submit() {
        if (this.btnLoading) {
            return;
        }
        this.btnLoading = true;
        this.$refs.formCustom
            .validate(async valid => {
                if (valid && this.editorLength > 0 && this.editorLength <= 10000) {
                    try {
                        if (this.isEdit) {
                            await api.rgApi.updateRgTemplate(this.templateId, {
                                name: this.formCustom.name,
                                content: this.formCustom.content
                            });
                        } else {
                            await api.rgApi.addRgTemplate({
                                name: this.formCustom.name,
                                content: this.formCustom.content,
                                rgId: this.rgId
                            });
                        }
                        this.$mtd.message({
                            message: this.isEdit ? '编辑 RG 模板成功' : '添加 RG 模板成功',
                            type: 'success'
                        });
                        this.$emit('success');
                        this.visible = false;
                        this.handleClose();
                    } catch (e) {
                        console.log(e);
                    }
                }
            })
            .catch(e => e);
        this.btnLoading = false;
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
    get editorLength() {
        return this.formCustom.content.length;
    }
    // 取消编辑
    cancelSave() {
        this.$mtd
            .confirm({
                title: '确定要离开吗？系统可能不会保存您所做的更改',
                width: '433px',
                showCancelButton: true,
                type: 'warning',
                okButtonText: '确定',
                onOk: () => {
                    this.visible = false;
                    this.handleClose();
                }
            })
            .catch(e => e);
    }
    handleClose() {
        this.$emit('close');
    }
}
